import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { DatePipe } from "@angular/common";
import { Loggerservice } from "../../../services/logger-service";
import { Router } from "@angular/router";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-rate-per-mile",
  templateUrl: "./rate-per-mile.component.html",
  styleUrls: ["./rate-per-mile.component.css"],
  providers: [DatePipe]
})
export class RatePerMileComponent implements OnInit {
  searchlist: boolean = true;
  loader: any = false;
  showList: boolean = false;
  nameExist: boolean = false;
  searchresult: boolean = false;
  newDate: any = new Date();
  endDateInvalid: boolean = false;
  previousData: any = [];
  rejected;

  aprvbtn = false;
  approveStatus;
  isApproved = false;
  updateApprove = false;
  rpmid;

  rpmValueNotNumeric: boolean = false;
  notValidRpmValue: boolean = false;
  cancellatonPValueNotNumeric: boolean = false;
  notValidPercentage: boolean = false;

  viewTitle: string = "Rate Per Mile Master";
  insertDataTitle: string = "Rate Per Mile Master";
  screentitle: string = "Rate Per Mile Master";
  actionmode: string = "Seacrh";
  parent_table = "rate_per_mile";
  parent_table_ID = "RATE_PER_MILE_ID";
  TIER_TYPE = "TIER_TYPE";
  RPM = "RPM";
  CANCELLATION_PENALTY = "CANCELLATION_PENALTY";
  APPLICABLE_FROM = "APPLICABLE_FROM";
  APPLICABLE_TO = "APPLICABLE_TO";
  minRemark = false;
  APPROVAL_STATUS = "APPROVAL_STATUS";
  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  Parent_result_ID = "";
  dbFields = [
    this.TIER_TYPE,
    this.RPM,
    this.CANCELLATION_PENALTY,
    this.APPLICABLE_FROM,
    this.APPLICABLE_TO
  ];
  dbFieldss = [
    this.TIER_TYPE,
    this.RPM,
    this.CANCELLATION_PENALTY,
    this.APPLICABLE_FROM,
    this.APPLICABLE_TO,
    "STATUS"
  ];
  searchitem = " ";
  searchColumn = " ";
  childtables = [];
  filters = [];
  screen_details: any = [];
  search_details: any = [];
  serachtabledata: any = [];
  serachTableInfo: any = [];
  data: any = [];
  status: any = {};
  sortType = "";
  p: number = 1;
  fileImportInput: any;
  // tiers: any = ["Blue Plus", "Silver", "Gold", "Platinum"];
  tiers: any = [
    { key: "BLUEPLUS", value: "Blue Plus" },
    { key: "SILVER", value: "Silver" },
    { key: "GOLD", value: "Gold" },
    { key: "PLATINUM", value: "Platinum" }
  ];
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";

  constructor(
    private vernostService: VernostServiceService,
    private datePipe: DatePipe,
    private logService: Loggerservice,
    private commonService : CommonService,
    private router: Router
  ) {}

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    // alert("fid"+this.fid);
    console.log(this.fid);
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    var rollArrayRatePerMile = {
      funId: this.fid,
      roleID: this.roleID
    };
    console.log("this.roleID ", this.roleID);
    this.vernostService.checkFunAccess(rollArrayRatePerMile).subscribe(response => {
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    this.screen_details = {
      TIER_TYPE: "",
      RPM: "",
      CANCELLATION_PENALTY: "0",
      APPLICABLE_FROM: "",
      APPLICABLE_TO: ""
    };
    this.search_details = {
      TIER_TYPE: "",
      RPM: ""
    };
    this.showList = false;
  }

  checkAproval() {
    var dbFieldRatePerMile = [this.APPROVAL_STATUS];
    var arrRatePerMile = {
      dbField: dbFieldRatePerMile,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrRatePerMile).subscribe(res => {
      let status = JSON.stringify(res[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  changeName() {
    // alert(this.Parent_result_ID);
    var dataRPM = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "RATE_PER_MILE_ID"
    };

    this.vernostService.getSTATUS(dataRPM).subscribe(res => {
      this.approveStatus = res[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

  gotochangestatus() {
    document.getElementById("errs").innerHTML = "";
    if (this.actionmode == "Edit") {
      var dataRatePerMile = {
        parent_table: this.parent_table,
        formData: this.Parent_result_ID,
        columnName: this.parent_table_ID
      };

      this.vernostService.editstatus(dataRatePerMile).subscribe(response => {
        this.isApproved = false;
      });
    }
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

  /*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    var data_rpm = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "RATE_PER_MILE_ID",
      status: status
    };

    this.vernostService.changeSTATUS(data_rpm).subscribe(resp => {
      this.searchData();
    });
  } */

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'rate-per-mile');
  }

  aproveReject(status) {
    this.isApproved = true;
    var currentTime = new Date();
    //console.log(MODIFIED_TIME);
    let dbFieldRatePerMile = [
      this.APPROVAL_STATUS,
      this.APPROVAL_REMARKS,
      this.APPROVAL_BY,
      "STATUS",
      "APPROVAL_DATE_TIME"
    ];
    if (status == 1) {
      this.approveStatus = 1;
    }
    var formDataRatePerMile = [
      status,
      this.aprove_details.APPROVAL_REMARKS,
      this.uid,
      status,
      currentTime
    ];
    var array = {
      dbField: dbFieldRatePerMile,
      parent_table: this.parent_table,
      formData: formDataRatePerMile,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    console.log("aaart=" + JSON.stringify(array));
    this.vernostService.aproveReject(array).subscribe(response => {
      this.aprove_details.APPROVAL_REMARKS = "";
      if (status == 2) {
        this.rejected = 2;
        //   this.searchForm();
        //   this.searchData();

        this.logService.create_log_RPM(
          "'Component Name':RPM Master,'Action':Reject Record,'Modified by':" +
          localStorage.getItem("fname") +
          "'Record':" +
          JSON.stringify(this.screen_details),
          "info"
        );
      } else {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }

        if (response[0].aproval == "aproved") {
          this.aprvbtn = false;
          // this.aprovebtn=false;
          //  alert(JSON.stringify(response[0].status));
          //  this.searchForm();

          this.logService.create_log_RPM(
            "'Component Name':RPM Master,'Action':Approve Record,'Modified by':" +
            localStorage.getItem("fname") +
            "'Record':" +
            JSON.stringify(this.screen_details),
            "info"
          );
        }
        this.aprvbtn = false;
        /* if (response[0].aproval == "rejected") {
          this.aprvbtn = false;
          // this.aprovebtn=false;
          //  alert(JSON.stringify(response[0].status));
          //this.searchForm();
        } else {
          this.aprvbtn = false;
          // alert("in else");
          // this.rejectbtn=false;
          // alert(JSON.stringify(response[0].status));
          // this.searchForm();
        } */
      }
      if (this.actionmode == "Edit") {
        console.log("@@@@@@@@@");
        this.submitdata();
      }
      this.searchData();
    });
  }
  setId(id) {
    this.Parent_result_ID = id;
  }

/*
  count1 = 0;
  count2 = 0;
  sortByOrder_rpm(data, number) {
    if (number == 1) {
      if (this.count1 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count1++;
      this.count2 = 0;
    }
    if (number == 2) {
      if (this.count2 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count2++;
      this.count1 = 0;
    }
    var arrayRatePerMile = {
      sortField: data,
      parent_table: this.parent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayRatePerMile).subscribe(response => {
      this.serachtabledata = response;
    });
  } */

  addForm() {
    this.rejected = 0;
    this.Parent_result_ID = "";
    this.showList = false;
    this.actionmode = "Add";
    this.rpmValueNotNumeric = false;
    this.notValidRpmValue = false;
    this.cancellatonPValueNotNumeric = false;
    this.notValidPercentage = false;
    this.endDateInvalid = false;
    document.getElementById("errs").innerHTML = "";
  }

  searchForm() {
    this.rejected = 0;
    this.search_details = {
      TIER_TYPE: "",
      RPM: ""
    };

    this.screen_details = {
      TIER_TYPE: "",
      RPM: "",
      CANCELLATION_PENALTY: "",
      APPLICABLE_FROM: "",
      APPLICABLE_TO: ""
    };
    this.actionmode = "Search";
    this.rpmValueNotNumeric = false;
    this.notValidRpmValue = false;
    this.cancellatonPValueNotNumeric = false;
    this.notValidPercentage = false;
    this.endDateInvalid = false;
    this.searchData();
    document.getElementById("errs").innerHTML = "";
  }

  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        //alert("already approved");
        this.isApproved = true;
      }
    }
    console.log("this.Parent_result_ID :", this.Parent_result_ID);

    this.Parent_result_ID = formData;
    var array = {
      parent_table: this.parent_table,
      dbFields: this.dbFieldss,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    this.vernostService.getData(array).subscribe(response => {
      this.rpmid = response[0].result[0].RATE_PER_MILE_ID;
      console.log("rpmid" + this.rpmid);
      this.screen_details = {
        TIER_TYPE: response[0].result[0].TIER_TYPE,
        RPM: response[0].result[0].RPM,
        CANCELLATION_PENALTY: response[0].result[0].CANCELLATION_PENALTY,
        APPLICABLE_FROM: response[0].result[0].APPLICABLE_FROM,
        APPLICABLE_TO: response[0].result[0].APPLICABLE_TO
      };
      this.serachTableInfo = response[0].result;
      this.previousData = response[0].result;
      this.approveStatus = response[0].result[0].STATUS;
      console.log(toggle);

      if (toggle == "1") {
        this.showList = true;
        this.actionmode = "View";
      }
      if (toggle == "3") {
        this.showList = false;
        this.actionmode = "View";
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  checkStartDate(event) {
    this.endDateInvalid = false;
    this.gotochangestatus();
    document.getElementById("errs").innerHTML = "";
    if (this.screen_details.APPLICABLE_TO != "") {
      this.screen_details.APPLICABLE_FROM = this.datePipe.transform(
        this.screen_details.APPLICABLE_FROM,
        "yyyy-MM-dd"
      );
      this.screen_details.APPLICABLE_TO = this.datePipe.transform(
        this.screen_details.APPLICABLE_TO,
        "yyyy-MM-dd"
      );
      console.log("APPLICABLE_FROM", this.screen_details.APPLICABLE_FROM);
      console.log("APPLICABLE_TO", this.screen_details.APPLICABLE_TO);

      if (
        this.screen_details.APPLICABLE_FROM > this.screen_details.APPLICABLE_TO
      ) {
        this.endDateInvalid = true;
      } else {
        this.endDateInvalid = false;
      }
    }
  }
  checkEndDate(event) {
    this.gotochangestatus();
    document.getElementById("errs").innerHTML = "";
    if (this.screen_details.APPLICABLE_FROM != "") {
      this.screen_details.APPLICABLE_FROM = this.datePipe.transform(
        this.screen_details.APPLICABLE_FROM,
        "yyyy-MM-dd"
      );
      this.screen_details.APPLICABLE_TO = this.datePipe.transform(
        this.screen_details.APPLICABLE_TO,
        "yyyy-MM-dd"
      );

      if (
        this.screen_details.APPLICABLE_TO < this.screen_details.APPLICABLE_FROM
      ) {
        this.endDateInvalid = true;
      } else {
        this.endDateInvalid = false;
      }
    }
  }

  submitdata() {
    console.log("this.Parent_result_ID :", this.Parent_result_ID);
    console.log("this.Parent_result_ID :", this.screen_details);
    if (
      this.screen_details.TIER_TYPE == "" ||
      this.screen_details.TIER_TYPE == undefined ||
      this.screen_details.RPM == "" ||
      this.screen_details.RPM == undefined ||
      this.screen_details.APPLICABLE_FROM == "" ||
      this.screen_details.APPLICABLE_FROM == undefined ||
      this.screen_details.APPLICABLE_TO == "" ||
      this.screen_details.APPLICABLE_TO == undefined
    ) {
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      this.screen_details.APPLICABLE_FROM = this.datePipe.transform(
        this.screen_details.APPLICABLE_FROM,
        "yyyy-MM-dd"
      );
      this.screen_details.APPLICABLE_TO = this.datePipe.transform(
        this.screen_details.APPLICABLE_TO,
        "yyyy-MM-dd"
      );
      var formData = [
        this.screen_details.TIER_TYPE,
        this.screen_details.RPM,
        this.screen_details.CANCELLATION_PENALTY,
        this.screen_details.APPLICABLE_FROM,
        this.screen_details.APPLICABLE_TO
      ];
      //  alert(this.screen_details.RPM);
      console.log(formData);
      console.log("this.Parent_result_ID :", this.Parent_result_ID);
      if (this.actionmode == "Edit") {
        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          parent_table_ID: this.parent_table_ID,
          formData: formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid
        };
        this.vernostService.editRPMData(array).subscribe(response => {
          //    alert("in edit");
          console.log(JSON.stringify(response[0].message));
          if (response[0].message == "Update Fail") {
            document.getElementById("errs").innerHTML =
              "Tier Type is already present for selected date range";
          } else {
            // this.searchForm();
            document.getElementById("errs").innerHTML =
              "Record updated Successfully";
            this.loader = false;

            this.logService.create_log_RPM(
              "'Component Name':RPM Master,'Action':Update Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Privious Record':" +
              JSON.stringify(this.previousData) +
              ",'New Record':" +
              JSON.stringify(this.screen_details),
              "info"
            );
          }
        });
      }
      if (this.actionmode != "Edit") {
        //alert("in submit");
        var Data = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          formData: formData,
          USER_ID: this.uid,
          PAGENAME: "RATEP"
        };
        //alert(JSON.stringify(Data));
        console.log("this.screen_details", this.screen_details);
        this.vernostService.insertData(Data).subscribe(response => {
          console.log(JSON.stringify(response[0].message));
          if (response[0].message == "Data inserted") {
            document.getElementById("errs").innerHTML =
              "Record Created Successfully";
            console.log(JSON.stringify(response[0].message));
            this.showFormData(response[0].addinfo, 3, 1, 1);

            this.logService.create_log_RPM(
              "'Component Name':RPM Master,'Action':Create Record,'Modified by':" +
              localStorage.getItem("fname") +
              ",'Record':" +
              JSON.stringify(this.screen_details),
              "info"
            );
          }
          if (response[0].message == "Data Not inserted") {
            console.log(JSON.stringify(response[0].message));
            document.getElementById("errs").innerHTML =
              "Tier Type is already present for selected date range";
          }
        });
      }
    }
  }

  // searchTiers: any = ["Blue Plus", "Silver", "Gold", "Platinum"];
  searchTiers: any = [
    { key: "BLUEPLUS", value: "Blue Plus" },
    { key: "SILVER", value: "Silver" },
    { key: "GOLD", value: "Gold" },
    { key: "PLATINUM", value: "Platinum" }
  ];
  searchData() {
    this.searchlist = false;
    this.loader = true;
    var field1 = this.search_details.TIER_TYPE;
    var field2 = this.search_details.RPM;

    if (field1 == "" && field2 == "") {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "") {
        searchitem.push(field1);
        searchColumn.push("TIER_TYPE");
      }
      if (field2 != "") {
        searchitem.push(field2);
        searchColumn.push("RPM");
      }

      var Data_RPM = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      this.vernostService.searchRecord(Data_RPM).subscribe(res => {
        if (res.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = res;
          this.searchresult = true;
          this.logService.create_log_RPM(
            "'Component Name':RPM Master,'Action':Srarch Record,'Modified by':" +
            localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record not found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function() {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  changenew(data) {
    var regx1 = /^[0-9.]*$/;
    var checkNumberAndDot = regx1.test(data);
    if (checkNumberAndDot == true) {
      this.rpmValueNotNumeric = false;
      var regx = /^[0-9]\d*(\.\d+)?$/;
      var checkValidValue = regx.test(data);
      if (checkValidValue == true) {
        this.notValidRpmValue = false;
      } else {
        this.notValidRpmValue = true;
      }
    } else {
      this.rpmValueNotNumeric = true;
    }
  }

  checkRPMValue(data) {
    document.getElementById("errs").innerHTML = "";
    this.rpmValueNotNumeric = false;
    this.notValidRpmValue = false;
    console.log(data);

    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      // this.RAC_APROVE = "1";
    }

    if (data == "" || data == undefined) {
      this.rpmValueNotNumeric = false;
      this.notValidRpmValue = false;
    }
  }

  checkCancellationPValue(data) {
    document.getElementById("errs").innerHTML = "";
    this.cancellatonPValueNotNumeric = false;
    this.notValidPercentage = false;
    console.log(data);
    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      // this.RAC_APROVE = "1";
    }

    var regx1 = /^[0-9]*$/;
    var checkNumberAndDot = regx1.test(data);
    if (checkNumberAndDot == true) {
      this.cancellatonPValueNotNumeric = false;
      // var regx = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
      // var checkPercentage = regx.test(data);
      // if (checkPercentage == true) {
      //   this.notValidPercentage = false;
      // } else {
      //   this.notValidPercentage = true;
      // }
    } else {
      this.cancellatonPValueNotNumeric = true;
    }
  }

  checkNames() {
    var array = {
      columnName: "TIER_TYPE",
      dbFieldName: this.screen_details.TIER_TYPE,
      parent_table: this.parent_table
    };

    this.vernostService.checkName(array).subscribe(data => {
      if (data[0].status == "Sucess") {
        this.nameExist = false;
      } else {
        this.nameExist = true;
      }
    });
  }
  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }
  checkRemarkLength(data) {
    if (data.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }

  getremark(val) {
    this.minRemark = false;
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }
}
